<template>
  <div v-if="sortedResults.length" class="border-b border-black-30 sm:border-none">
    <div class="flex flex-col">
      <div class="fs-24 font-medium sm:px-6 search-result flex-1 flex items-center pr-4">
        <h1 v-html="summary"></h1>
      </div>

      <div class="mdsm:hidden inline-flex items-center my-6">
        <label class="mr-2 inline-block font-medium">Sort By:</label>
        <custom-select
          class="ranking-dropdown"
          v-model="sortBy"
          placeholder="Sort By"
          :options="sortOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import CustomSelect from '../../components/core/CustomSelect'

export default {
  components: {
    CustomSelect
  },
  data() {
    return {
      sortOptions: [
        { label: 'Shortest first', value: 'shortest-first' },
        { label: 'Longest first', value: 'longest-first' },
        { label: 'Price', value: 'price' },
      ]
    }
  },
  computed: {
    ...mapState(['ranking']),
    ...mapGetters(['sortedResults']),
    sortBy: {
      get() {
        return this.ranking
      },
      set(val) {
        this.setRanking(val)
        this.setPage(1)
      }
    },
    summary () {
      if (this.sortedResults.length === 1) {
        return `1 ecoventure`
      }
      
      return `${this.sortedResults.length} ecoventures`
    }
  },
  methods: {
    ...mapMutations(['setRanking', 'setPage'])
  }
}
</script>
